import { Button } from "antd";
import React, { useEffect, useRef, useState } from "react";
import "antd/dist/antd.css";
import PropertyBar from "./Tools/PropertyBar";
import { HandleDownloadBtnClick } from "../CommonFunctions/HeaderFunctions";
import { useDispatch, useSelector } from "react-redux";
import { downloadPages, setUpdatedCanvas, previewPages } from "../slices/creatorSlice";
import { fabric } from "fabric-webpack";
import { saveAs } from "file-saver";
import PageSize from "./Tools/PageSize";
import { Carousel } from 'antd';
import { Modal } from 'antd';
const CanvasHeader = ({ canvas }) => {
  const _Canvaces = useSelector((state) => state.creator.canvases);
  const _CurrentSlide = useSelector((state) => state.creator.currentSlide);
  const _ExecuteDownload = useSelector(
    (state) => state.creator.executeDownload
  );
  const _ExecutePreview = useSelector(
    (state) => state.creator.executePreview
  );
  const dispatch = useDispatch();
  const duplicateCanvas = useRef(null);
  const [d_canvas, setD_Canvas] = useState();
  const _CanvasSize = useSelector((state) => state.creator.canvasSize);
    const [isCarouselOpen, setIsCarouselOpen] = useState(false)
    const [previewImages, setPreviewImages] = useState([])
  function getCanvas(newObj) {
    return async (dispatch) => {
      await dispatch(
        setUpdatedCanvas({ canvasIndex: _CurrentSlide, data: newObj })
      );
    };
  }

  const exportCanvases = async () => {
    var newObj = await canvas.toDatalessJSON();
    getCanvas(newObj);
    // dispatch(setUpdatedCanvas({ canvasIndex: _CurrentSlide, data: newObj }));

    var blob = new Blob([JSON.stringify(_Canvaces)], {
      type: "text/plain;charset=utf-8;",
    });
    saveAs(blob, "canvas-exported.json");
  };

  const initCanvas = () => {
    return new fabric.Canvas(duplicateCanvas.current, {
      height: _CanvasSize.height,
      width: _CanvasSize.width,
      backgroundColor: "#000000",
    });
  };

  //set initial canvas
  useEffect(() => {
    setD_Canvas(initCanvas());
  }, []);
  //dependency array ensure that the duplicate canvas is same as a size of original canvas.
  useEffect(() => {
    if (d_canvas) {
      d_canvas.setHeight(_CanvasSize.height);
      d_canvas.setWidth(_CanvasSize.width);
      d_canvas.renderAll();
    }
  }, [_CanvasSize]);

  //when user click on the download button executedownload change and download function will call.
  useEffect(() => {
    if (_ExecuteDownload !== 0) {
      HandleDownloadBtnClick(_Canvaces, d_canvas);
    }
  }, [_ExecuteDownload]);
  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  const hanldePreviewClick = () => {
    const updatedCanvasData = canvas.toDatalessJSON();
              dispatch(
                setUpdatedCanvas({
                  canvasIndex: _CurrentSlide,
                  data: updatedCanvasData,
                })
              );
              dispatch(previewPages())
    setIsCarouselOpen(!isCarouselOpen);
  }
const loadPreviewImages = async()=>{
  _Canvaces.map(async(canvasdata)=>{
    var json = JSON.stringify(canvasdata)
             d_canvas.loadFromJSON(json, ()=>{
  d_canvas.renderAll();
const dataURL = d_canvas.toDataURL({
                   width: canvas.width,
                   height: canvas.height,
                   left: 0,
                   top: 0,
                   format: "png",
                 })
                setPreviewImages((data)=>[...data, dataURL])
                d_canvas.clear();
  d_canvas.setBackgroundImage(null);
  d_canvas.backgroundColor = "#ffffff";
  d_canvas.renderAll();
             })
      })
}
  useEffect(()=>{
    if(d_canvas){
      loadPreviewImages()
    }
  },[_ExecutePreview])
  return (
    <>
      <div className="flex justify-between items-center bg-transparent py-2 pl-4 mt-2">
        {/* Canvas Option Dropdown menu */}
        <PageSize canvas={canvas} />

        {/* ANT Design Propertybar  */}
        <PropertyBar canvas={canvas} />

        {/* preview and download buttons */}
        <div className="flex justify-center items-center w-max px-4 cursor-pointer">
          <Button
            onClick={() => {
              exportCanvases();
            }}
            type="default"
            shape="round"
            className="mr-1 cursor-pointer"
          >
            Export
          </Button>
          <Button type="default" shape="round" className="mr-1 cursor-pointer" onClick={hanldePreviewClick}>
            Preview
          </Button>
          {/* {isCarouselOpen ? (
          <div className="relative hhhaaa"></div>) : null} */}
          <Modal visible={isCarouselOpen} onCancel={()=>{
            setIsCarouselOpen(!isCarouselOpen)
            setPreviewImages([])
          }}>
          <div className="w-full mt-4">
            <Carousel afterChange={onChange} className="h-screen w-full bg-blue-500">
          {
            previewImages.map((images, i)=>{
              return(
                <div key={i} className='h-auto w-full flex justify-center items-center shadow-lg rounded'>
                <img src={images} className='h-auto w-full' alt="preview images" />
                </div>
              )
            })
          }
    </Carousel>
    </div>
          </Modal>
          <Button
            type="primary"
            shape="round"
            className="ml-1 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              const updatedCanvasData = canvas.toDatalessJSON();
              dispatch(
                setUpdatedCanvas({
                  canvasIndex: _CurrentSlide,
                  data: updatedCanvasData,
                })
              );
              dispatch(downloadPages());
            }}
          >
            Download
          </Button>
          {/* this is canvas is used only for download images and it is hidden */}
          <div style={{ display: "none" }} className="bg-transparent">
            <canvas
              width={_CanvasSize.width}
              height={_CanvasSize.height}
              ref={duplicateCanvas}
              className="bg-transparent"
            ></canvas>
          </div>
        </div>
      </div>
    </>
  );
};

export default CanvasHeader;
